<template>
  <v-toolbar :color="hasSelectedItems ? 'rgba(17, 138, 202, 0.1)' : undefined" elevation="0" dense>
    <v-tooltip
      :disabled="!disabled"
      bottom
    >
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <v-checkbox
          @change="handleCheckboxClick"
          :value="selectedAll"
          :indeterminate="indeterminate"
          :disabled="disabled"
          :label="label"
          color="primary"
          hide-details
          dense
        />
      </div>
      </template>
      <span>{{ disabledTooltipText }}</span>
    </v-tooltip>
    <div v-if="hasSelectedItems" class="primary--text">{{ selectedPagamentoItensCount | pluralize }} de {{ totalPagamentoItens }}</div>
    <v-spacer />
    <v-tooltip
      v-if="hasSelectedItems"
      :disabled="pagamentoLoteStatus === 'conciliacaoManual'"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on" v-bind="attrs">
          <v-menu :disabled="pagamentoLoteStatus !== 'conciliacaoManual'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary" outlined small>
                Ações
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-for="item in showMenuItens"
                :key="item.title"
                @click="item.action"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
    <template v-else>
      <div class="mr-2">
        <conciliacao-pagamento-itens-sort />
      </div>
      <conciliacao-pagamento-itens-filter />
    </template>
  </v-toolbar>
</template>

<script>
import { pagamentoLoteStatusLabels } from '@tradimus/api-conciliacao-client'
import { mapGetters, mapState } from 'vuex'
import { conciliacaoClient } from '../../../libs'
import ConciliacaoPagamentoItensFilter from './ConciliacaoPagamentoItensFilter.vue'
import ConciliacaoPagamentoItensSort from './ConciliacaoPagamentoItensSort.vue'

export default {
  components: {
    ConciliacaoPagamentoItensFilter,
    ConciliacaoPagamentoItensSort
  },
  computed: {
    ...mapState('conciliacao', ['pagamentoId', 'pagamentoLoteId', 'showFaturamentoItens']),
    ...mapGetters(
      'conciliacao',
      ['selectedPagamentoItensCount', 'selectedPagamentoItensIds', 'totalPagamentoItens', 'pagamentoLoteStatus', 'selectedFaturamentoItensCount', 'hasItemSistema', 'hasSelectedPagamentoItemConciliado','hasSelectedFaturamentoItemConciliado']
    ),
    selectedAll () {
      return this.selectedPagamentoItensCount > 0 && this.selectedPagamentoItensCount === this.totalPagamentoItens
    },
    indeterminate () {
      return this.selectedPagamentoItensCount > 0 && this.selectedPagamentoItensCount < this.totalPagamentoItens
    },
    disabledByNN () {
      return this.totalPagamentoItens === 0 || !this.showFaturamentoItens || this.selectedFaturamentoItensCount > 1
    },
    disabledByItemSistema () {
      return this.hasItemSistema && this.hasSelectedFaturamentoItemConciliado
    },
    disabled () {
      return this.disabledByNN || this.disabledByItemSistema
    },
    disabledTooltipText () {
      if (this.disabledByNN) {
        return 'Não é possível selecionar mais de um item.'
      } else if (this.disabledByItemSistema) {
        return 'Não é possível conciliar restante de guia com item já conciliado.'
      } else {
        return ''
      }
    },
    label () {
      return this.selectedPagamentoItensCount === 0 ? 'Selecionar todos os itens' : undefined
    },
    hasSelectedItems () {
      return this.selectedPagamentoItensCount > 0
    },
    hasConciliacaoItems () {
      return this.hasSelectedPagamentoItemConciliado
    },
    tooltipText () {
      return `Lote de pagamento apresenta status ${pagamentoLoteStatusLabels[this.pagamentoLoteStatus]}. Não é possível alterar a conciliação.`
    },
    isUsuarioTradimus () {
      const isUsuarioTradimus = JSON.parse(sessionStorage.getItem('userData'))
      return isUsuarioTradimus.UsuarioTradimus
    },
    menuItems () {
      return [
        { title: 'Desconciliar itens selecionados', action: this.handleDesconciliarClick, show: true },
        { title: 'Invalidar itens selecionados', action: this.handleInvalidarClick, show: this.isUsuarioTradimus },
        { title: 'Marcar itens como recurso', action: this.marcarRecurso, show: true }
      ]
    },
    showMenuItens () {
      return this.menuItems.filter(menuItem => menuItem.show)
    }
  },
  methods: {
    handleCheckboxClick (checked) {
      if (checked) {
        this.$store.dispatch('conciliacao/selectAllPagamentoItens')
      } else {
        this.$store.dispatch('conciliacao/deselectAllPagamentoItens')
      }
    },
    handleDesconciliarClick () {
      const paramModal = {
        type: "warning",
        title: "Desconciliar itens",
        message: "Esta ação desconciliará todos os itens de faturamento associados. <br>Esta ação não pode ser desfeita.<br>",
        callback: this.desconciliarItens,
        btConfirm: { name: "Ok", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    async desconciliarItens () {
      const command = {
        pagamentoId: this.pagamentoId,
        data: [{
          pagamentoLoteId: this.pagamentoLoteId,
          pagamentoItemIds: this.selectedPagamentoItensIds
        }]
      }

      try {
        await conciliacaoClient.pagamento.desconciliar(command)
        this.$store.dispatch('conciliacao/conciliacaoItensDeleted')
      } catch (error) {
        this.showErrorModal('Erro ao desconciliar itens')
      }
    },
    handleInvalidarClick () {
      if(this.hasConciliacaoItems){
        const paramModalInfo = {
        type: "warning",
        title: "Atenção",
        message: "Não é possível invalidar itens já conciliados!",
        btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModalInfo);
      }
       else{
      const paramModal = {
        type: "warning",
        title: "Invalidar itens",
        message: "Após concluir esta ação, os itens não seram mais exibidos. <br>Esta ação não pode ser desfeita.<br>",
        callback: this.invalidarItens,
        btConfirm: { name: "Ok", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    }
  },
    async invalidarItens () {
      const data = {
        pagamentoItens: this.selectedPagamentoItensIds,
        itemValido: false
      }

      try {
        await conciliacaoClient.pagamentoItem.updatePagamentoItensItemValido(data)
        this.$store.dispatch('conciliacao/pagamentoItensInvalidated')
      } catch (error) {
        location.reload()
      }
    },
    async marcarRecurso () {
      const data = {
        pagamentoItens: this.selectedPagamentoItensIds,
        tipoRegistro: 'recurso'
      }

      try {
        await conciliacaoClient.pagamentoItem.updatePagamentoItensTipoRegistro(data)
        this.$store.dispatch('conciliacao/pagamentoItensTipoRegistroUpdated')
      } catch (error) {
        this.showErrorModal('Erro ao marcar itens como recurso')
      }
    },
    showErrorModal (message) {
      const modalParams = {
        type: 'error',
        title: message,
        btConfirm: {
          name: 'Ok',
          show: true,
          color: 'primary'
        }
      }

      this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
    }
  },
  filters: {
    pluralize (count) {
      if (count === 0) {
        return 'Nenhum item selecionado'
      } else if (count === 1) {
        return '1 item selecionado'
      } else {
        return `${count} itens selecionados`
      }
    }
  }
}
</script>
